<template>
  <div style="width: 100%;height: 100%;position: fixed;">
    <el-header style="display: flex;justify-content: space-between;">
      <div class="logo_nav">
        <img
          height="100%"
          v-if="profile.logo || logoUrlObj.logo"
          :src="`${profile.logo ? profile.logo : logoUrlObj.logo}`"
          alt="fsgo logo"
        />
      </div>

      <div class="header_quick">
        <div class="navtools">
          <div class="icon-tool" @click="handleFullScreen">
            <i class="el-icon-full-screen"></i>
          </div>
          <el-divider direction="vertical"></el-divider>
          <div class="user-tool">
            <el-dropdown
              class="demo"
              ref="dropdown"
              trigger="click"
              placement="bottom"
              :hide-on-click="false"
              @command="dropdownCommand"
            >
              <span class="el-dropdown-link">
                <img
                  v-if="profile.avatar && profile.avatar.length > 50"
                  class="photo"
                  :src="profile.avatar"
                />
                <img v-else class="photo" src="../assets/user.png" />
                {{ account.nickname || '请登陆账号' }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="false" @click.native.prevent="isAccountPopover = false">
                  <el-popover
                    :disabled="isAccountPopover"
                    placement="left"
                    width="300"
                    trigger="click"
                  >
                    <el-table :data="fpi.data">
                      <el-table-column>
                        <template slot="header">
                          <el-link
                            type="primary"
                            @click.native="$router.push({ path: '/Account' })"
                            href="javascript:;"
                          >
                            所有账号
                          </el-link>
                        </template>
                        <template slot-scope="scope">
                          <el-link @click="loginChange(scope.row)">
                            {{ scope.row.nickname || profile.name }}：{{
                              scope.row.email || scope.row.phone || profile.email
                            }}
                          </el-link>
                          <div style="color:#888">
                            所在公司：{{ scope.row.tenantName || profile.name }}
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div slot="reference">
                      <div>
                        <div style="font-weight:700;">账户名</div>
                        <div style="font-size:12px;color:##999">
                          {{ account.nickname || '请选择账号' }}
                        </div>
                      </div>
                    </div>
                  </el-popover>
                </el-dropdown-item>
                <el-dropdown-item command="true" divided @click.native="logout">
                  退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </el-header>
    <div class="gray-gap"></div>
    <div class="title-wrapper">
      <div style="font-size: 18px;">
        <i class="el-icon-info" style="margin-right:4px"></i>
        选择所要登陆的账号
      </div>
      <div class="c-flex" v-if="false">
        <el-input
          placeholder="请输入账户名称"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
      </div>
    </div>
    <div class="content-box">
      <div class="content-table">
        <!--calc(100% - 50px) -->
        <el-table height="calc(100% - 140px)" :data="fpi.data" border highlight-current-row>
          <el-table-column prop="nickname" label="账户名称">
            <template slot-scope="scope">
              {{ scope.row.name || scope.row.tenantName }}
            </template>
          </el-table-column>
          <el-table-column prop="tenantName" label="所在公司"></el-table-column>
          <el-table-column prop="email" label="邮箱"></el-table-column>
          <el-table-column prop="phone" label="手机号"></el-table-column>
          <el-table-column prop="roleIds" label="角色" :formatter="formatRole"></el-table-column>
          <el-table-column fixed="right" width="105" label="操作">
            <template slot-scope="scope">
              <el-button @click.native.prevent="loginChange(scope.row)" size="mini">
                点击登陆
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="false"
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/logo_nav.png';
import logo_sub from '@/assets/logo_sub_nav.png';
export default {
  data() {
    return {
      tenantId: '',
      profile: {},
      //本地图片
      logoUrlObj: {
        logo: logo,
        logo_sub: logo_sub
      },
      fpi: { data: [] },
      user: {},
      searchValue: '',
      roleList: [], //角色列表
      account: {}, //账户
      isAccountPopover: false, //右上角选择账户窗口的显示隐藏
      fsgoUnionId: ''
    };
  },
  mounted() {
    let entity = JSON.parse(sessionStorage.getItem('entity'));
    this.fsgoUnionId = entity.fsgoUnionId;
    this.user._id = entity.entityID;
    this.tenantId = entity.tenantId;
    this.getData().then(roleIds => {
      this.getRole(roleIds);
    });
    this.getProfile();

    this.account = JSON.parse(sessionStorage.getItem('loginAccount')) || {};
    console.log(this.account);
  },
  methods: {
    getData() {
      return new Promise(reslove => {
        let params = {
          page: this.fpi.page,
          rows: this.fpi.rows,
          sortField: 'createTime',
          sortOrder: 'desc',
          // userId: this.user._id
          fsgoUnionId: this.fsgoUnionId
        };
        //添加过滤器参数
        // $that.getParams(params);
        this.osg.ajax('account/getUserListByFsgoUnionId.do', params, res => {
          // res.data.map(item => {
          //   item.title = item.nickname;
          //   item.label = item.tenantNsame;
          // });
          // this.accountList = res.data;
          this.fpi.data = res.data;
          // this.fpi = res;
          console.log(this.fpi.data);
          reslove({
            roleIds: res.data.map(item => item.roleIds)
          });
        });
      });
    },
    //获取当前租户信息
    getProfile() {
      return new Promise(resolve => {
        this.osg.ajax(`tenant/find/${this.tenantId}.do`, {}, res => {
          if (res.entity) this.profile = res.entity;
          //设置浏览器icon图标/title
          document.querySelector('#titleBroswer').innerHTML = !this.profile.browserTitle
            ? 'FSGO'
            : this.profile.browserTitle;
          document.querySelector('#iconTitleBroswer').href = !this.profile.browserIcon
            ? './favicon.ico'
            : this.profile.browserIcon;
          //设置主题色（按钮...）
          if (res.entity) this.$util.customizeMenuChange(res.entity.menuBarBgColor);
        });
        resolve();
      });
    },
    //自动登陆开关
    handleSwitch(id) {
      this.fpi.data = this.fpi.data.map(item => {
        item.isPin = false;
        if (item._id == id) item.isPin = true;
        return item;
      });
    },
    //个人切换菜单
    dropdownCommand(commandVal) {
      if (commandVal == 'true') {
        this.$refs.dropdown.visible = false;
      } else {
        this.$refs.dropdown.visible = true;
      }
    },
    getRole(searchObj) {
      //数组扁平并去重
      // let roleIdsArr = Array.from(new Set());
      // console.log(roleIdsArr)
      //根据查询条件返回列表
      let params = {
        // "in:_id|array#and": searchObj.roleIds.join()
        roleIds: JSON.stringify(searchObj.roleIds.flat())
      };
      //添加过滤器参数
      // $that.getParams(params);
      this.osg.ajax('account/getRoleName.do', params, res => {
        // res.data.map(item => {
        //   item.label = item.xx;
        //   item.value = item.vv;
        // });
        this.roleList = res.data;
      });
    },
    //反显角色
    formatRole(row, column, cellValue, index) {
      let roles = '';
      for (let item of this.roleList) {
        if (cellValue.indexOf(item.value) != -1) roles += item.label + ' ';
      }
      return roles;
    },
    //点击登陆
    loginChange(row) {
      this.isAccountPopover = true;
      this.osg.ajax(
        'login/changeAccount.do',
        { userId: row._id },
        res => {
          sessionStorage.setItem('loginAccount', JSON.stringify(res.data.loginAccount));
          this.account = JSON.parse(sessionStorage.getItem('loginAccount')) || {};
          this.$message({
            message: '登陆成功!',
            type: 'success'
          });
          this.$router.push('/');
        },
        {
          noload: true
        }
      );
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    // 全屏事件
    handleFullScreen() {
      let element = document.documentElement;
      // 判断是否已经是全屏
      // 如果是全屏，退出
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        // 否则，进入全屏
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      // 改变当前全屏状态
      this.fullscreen = !this.fullscreen;
    },
    logout() {
      this.osg.ajax('logout', {}, res => {
        this.$util.cookie.deleteCookie(this.$util.cookieRelative.token);
        this.$router.push('/');
        sessionStorage.removeItem('loginAccount');
      });
    }
  }
};
</script>

<style scoped>
.logo_nav {
  padding: 4px;
  box-sizing: border-box;
}
.gray-gap {
  height: 8px;
  width: 100%;
  background: #f2f2f2;
}
.title-wrapper {
  display: flex;
  justify-content: space-between;
  padding: 24px 48px;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid #cbd6e2;
}
#app .content-table {
  flex: 1;
  overflow-x: hidden;
  padding: 40px 48px;
  background: #fff;
}
.content-box {
  height: 100%;
  background: #f2f2f2;
}
</style>
